import { createFileRoute } from '@tanstack/react-router'
import ImovelEditarPage from '@/pages/imoveis/imovel-editar'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota para editar um imóvel específico
// Path completo será /dashboard/$dashboardId/imoveis/$imovelId/editar
// Renderizada dentro do <Outlet /> de dashboard.$dashboardId.imoveis/$imovelId/route.tsx
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/editar',
)({
  component: function ImovelEditarRoute() {
    const { dashboardId, imovelId } = Route.useParams()
    return (
      <RequireModule module={MODULES.IMOVEIS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.EDIT_IMOB_DATA}>
          <ImovelEditarPage dashboardId={dashboardId} imovelId={imovelId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
